class SecondarySaleEndStockActions {
    static SECONDARYSALE_ENDSTOCK_REQUEST = "SECONDARYSALE_ENDSTOCK_REQUEST";
    static SECONDARYSALE_ENDSTOCK_SUCCESSFUL = "SECONDARYSALE_ENDSTOCK_SUCCESSFUL";
    static SECONDARYSALE_ENDSTOCK_FAILED = "SECONDARYSALE_ENDSTOCK_FAILED";

    

    static secondarySale_endStock_Request() {
        return {
            type: this.SECONDARYSALE_ENDSTOCK_REQUEST
        };
    }
    static secondarySale_endStock_Successul(data) {
        return {
            type: this.SECONDARYSALE_ENDSTOCK_SUCCESSFUL,
            data
        };
    }
    static secondarySale_endStock_Failed(error) {
        return {
            type: this.SECONDARYSALE_ENDSTOCK_FAILED,
            error
        };
    }


    //only end stock
    static ENDSTOCK_REQUEST = "ENDSTOCK_REQUEST";
    static ENDSTOCK_SUCCESSFUL = "ENDSTOCK_SUCCESSFUL";
    static ENDSTOCK_FAILED = "ENDSTOCK_FAILED";
    static endStock_Request() {
        return {
            type: this.ENDSTOCK_REQUEST
        };
    }
    static endStock_Successul(data) {
        return {
            type: this.ENDSTOCK_SUCCESSFUL,
            data
        };
    }
    static endStock_Failed(error) {
        return {
            type: this.ENDSTOCK_FAILED,
            error
        };
    }

     //only secondary sale
     static SECONDARYSALE_REQUEST = "SECONDARYSALE_REQUEST";
     static SECONDARYSALE_SUCCESSFUL = "SECONDARYSALE_SUCCESSFUL";
     static SECONDARYSALE_FAILED = "SECONDARYSALE_FAILED";

     static secondarySale_Request() {
         return {
             type: this.SECONDARYSALE_REQUEST
         };
     }
     static secondarySale_Successul(data) {
         return {
             type: this.SECONDARYSALE_SUCCESSFUL,
             data
         };
     }
     static secondarySale_Failed(error) {
         return {
             type: this.SECONDARYSALE_FAILED,
             error
         };
     }
}

export default SecondarySaleEndStockActions;
